<template>
  <div class="card shadow-sm h-100">
    <div class="p-4 pb-0 card-header">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
          <h6 class="mb-0">{{ title }}</h6>
        </div>
      </div>
    </div>
    <div class="p-4 card-body">
      <ul class="list-group">
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">제조사명:</strong> &nbsp; {{ info.name }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">주소:</strong> &nbsp; {{ info.address }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">연락처:</strong> &nbsp; {{ info.contactInfo }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">홈페이지:</strong> &nbsp; {{ info.homepage }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">라이센스 키:</strong> &nbsp; {{ info.companyPrefix }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">라이센스 타입:</strong> &nbsp; GS1 Company Prefix
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">국제 위치 식별번호:</strong> &nbsp; {{ info.gln }}
        </li>
        <li class="text-sm border-0 list-group-item ps-0">
          <strong class="text-dark">GS1 발급 기관:</strong> &nbsp; GS1 Global Office
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProfileInfoCard",
  components: {
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
